@if (addingPump) {
  <app-add-pump
    [mission]="mission"
    (closeModal)="closeAddPumpModal($event)">
  </app-add-pump>
}

@if (addingGateway) {
  <app-add-gateway
    [mission]="mission"
    (closeModal)="closeAddGatewayModal($event)">
  </app-add-gateway>
}

@if (addingFlowmeter) {
  <app-add-flowmeter
    [mission]="mission"
    (closeModal)="closeAddFlowmeterModal($event)">
  </app-add-flowmeter>
}

@if (addingSiteWellawareId) {
  <app-add-sitewellawareid
    (closeModal)="closeAddSiteWellawareIdModal($event)">
  </app-add-sitewellawareid>
}
